enum EVariant {
  created,
  updated,
  deleted
}

export default EVariant;
